import { useState, useRef, useCallback } from 'react';

type TimerHook = {
  time: number;
  start: () => void;
  stop: () => void;
  clear: () => void;
};

export const useTimer = (): TimerHook => {
  const [time, setTime] = useState<number>(0);
  const timerRef = useRef<NodeJS.Timeout | null>(null);

  const start = useCallback(() => {
    if (timerRef.current === null) {
      timerRef.current = setInterval(() => {
        setTime((prevTime) => prevTime + 1);
      }, 1000); // incrémente la valeur chaque seconde
    }
  }, []);

  const stop = useCallback(() => {
    if (timerRef.current !== null) {
      clearInterval(timerRef.current);
      timerRef.current = null;
    }
  }, []);

  const clear = useCallback(() => {
    stop(); // arrêter le timer s'il est en cours
    setTime(0); // réinitialiser le temps à 0
  }, [stop]);

  return { time, start, stop, clear };
};
